import React, { useMemo, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Search from '@groovehq/internal-design-system/lib/components/Search/Search'

import {
  selectProductsForQuery,
  selectCurrencyCode,
} from 'ducks/integrations/shopify'
import { styles } from './styles'
import ProductItem from './ProductItem'

const { Menu } = Dropdown

const menu = (variants, orderItems, currencyCode) => {
  return (
    <Menu css={styles.menu}>
      {variants.map(({ variant, product }) => (
        <Menu.Item key={variant.id} itemKey={variant.id}>
          <ProductItem
            name={
              product.hasOnlyDefaultVariant
                ? product.title
                : variant.displayName
            }
            image={product.featuredImage && product.featuredImage.url}
            sku={variant.sku}
            stock={variant.inventoryQuantity}
            currency={currencyCode}
            price={variant.price}
            orderItems={orderItems}
            variantId={variant.id}
          />
        </Menu.Item>
      ))}
    </Menu>
  )
}

const ProductsSearch = React.memo(
  ({ className, searchProducts, onAddItem, orderItems, integration }) => {
    const [value, setValue] = useState('')
    const handleChange = useCallback(
      evt => {
        const val = evt.target.value
        setValue(val)
        searchProducts(integration, val)
      },
      [setValue, searchProducts, integration]
    )
    const query = `title: ${value}`
    const products = useSelector(state =>
      selectProductsForQuery(state, { query })
    )
    const currencyCode = useSelector(state =>
      selectCurrencyCode(state, integration.id)
    )

    const results = useMemo(
      () => {
        const variants = []
        products.forEach(product => {
          const variantEdges = product.variants.edges
          const productVariants = variantEdges.map(edge => edge.node)
          productVariants.forEach(variant =>
            variants.push({ variant, product })
          )
        })
        return variants
      },
      [products]
    )
    const overlay = useMemo(() => menu(results, orderItems, currencyCode), [
      results,
      orderItems,
      currencyCode,
    ])
    const handleAddItem = variantId => {
      const result = results.find(({ variant }) => variant.id === variantId)
      if (result) onAddItem(result.variant)
    }

    return (
      <div className={className} css={styles.base}>
        <Dropdown overlay={overlay} onSelect={handleAddItem}>
          <Search
            onChange={handleChange}
            css={styles.search}
            placeholder="Search..."
          />
        </Dropdown>
      </div>
    )
  }
)

export default ProductsSearch
